import { MerchantSettlementComponent } from "../../components/organisms/report/MerchantSettlementComponent";
import { AdminTemplate } from "../../components";

export const MerchantSettlementPage = () => {
  return (
    <AdminTemplate
      headerProps={{
        headerTitle: "",
        hideAddButton: true,
        hideDownloadButton: true,
        hideSearchBar: true,
      }}
      showHeaderTitle={false}>
        <MerchantSettlementComponent/>
    </AdminTemplate>
  );
};
